var _defs, _path, _path2, _rect, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMidVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 1,
    width: 29,
    height: 29,
    color: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5d6-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6374f543b67f094e4896c5d6-1",
    d: "M15.83,10a2.84,2.84,0,0,1,0,4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6374f543b67f094e4896c5d6-1",
    d: "M17.84,8a5.7,5.7,0,0,1,0,8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6374f543b67f094e4896c5d6-1",
    x: 1.5,
    y: 8.21,
    width: 4.74,
    height: 7.58
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6374f543b67f094e4896c5d6-1",
    points: "13.82 3.47 13.82 20.53 12.16 20.53 6.24 15.79 6.24 8.21 12.16 3.47 13.82 3.47"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidVolume);
export default __webpack_public_path__ + "static/media/mid-volume.7c7a9db8ee4ea0aa6c8820b0acafea2d.svg";
export { ForwardRef as ReactComponent };